<div class="workspace-dropdown-container relative inline-block text-left">
  <button type="button"
          class="flex items-center space-x-2 text-sm font-semibold rounded-xl bg-gray-50 hover:opacity-90 dark:hover:bg-gray-700 px-3 py-1 transition-colors"
          (click)="toggleDropdown($event)"
          (mousedown)="$event.preventDefault()"
          [disabled]="disabled"
          aria-haspopup="true"
          [attr.aria-expanded]="showDropdown">
    <span class="text-lg text-violet-500 dark:text-primary-100">
      {{ currentWorkspace?.name || 'Select Workspace' }}
    </span>
    <svg xmlns="http://www.w3.org/2000/svg"
         fill="none"
         viewBox="0 0 24 24"
         stroke-width="2"
         stroke="currentColor"
         class="w-4 h-4 text-violet-500 dark:text-primary-100 transition-transform"
         [ngClass]="{'rotate-180': showDropdown}">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
    </svg>
  </button>

  <div *ngIf="showDropdown"
       class="absolute mt-1 w-64 max-h-80 overflow-y-auto origin-top-left rounded-xl bg-white dark:bg-gray-800 shadow-lg z-50 p-2"
       [ngClass]="dropdownPosition === 'right' ? 'right-0' : 'left-0'"
       [@dropdownAnimation]>

    <!-- Search input for many workspaces -->
    <div *ngIf="showSearch && workspaces.length > 5" class="px-2 pb-2">
      <input type="text"
             [(ngModel)]="searchQuery"
             (input)="filterWorkspaces()"
             (click)="$event.stopPropagation()"
             placeholder="Search workspaces..."
             class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white">
    </div>

    <!-- Loading state -->
    <div *ngIf="loading" class="flex justify-center items-center py-8">
      <svg class="animate-spin h-5 w-5 text-violet-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </div>

    <!-- Workspaces list -->
    <ul *ngIf="!loading && filteredWorkspaces.length > 0">
      <li
        *ngFor="let workspace of filteredWorkspaces"
        class="flex items-center px-4 py-2 text-sm rounded-lg cursor-pointer transition-colors"
        [ngClass]="{
          'bg-gray-50 dark:bg-gray-700': workspace.id === currentWorkspace?.id,
          'hover:bg-gray-50 dark:hover:bg-gray-700': workspace.id !== currentWorkspace?.id
        }"
        (click)="selectWorkspace(workspace, $event)"
      >
        <div [class]="'w-8 h-8 rounded-lg flex items-center justify-center text-white font-semibold text-xs mr-3 flex-shrink-0 ' + (workspace.color || 'bg-violet-500')">
          {{ workspace.initials }}
        </div>
        <div class="flex-1 min-w-0">
          <span class="font-medium text-gray-700 dark:text-gray-200 block truncate">
            {{ workspace.name }}
          </span>
          <span *ngIf="showDetails" class="text-xs text-gray-500 dark:text-gray-400">
            {{ workspace.searches_count || 0 }} reports
            <span *ngIf="workspace.icp">• {{ workspace.icp.name }}</span>
          </span>
        </div>
        <svg *ngIf="workspace.id === currentWorkspace?.id"
             class="w-4 h-4 text-violet-500 dark:text-violet-500 flex-shrink-0 ml-2"
             fill="currentColor"
             viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
        </svg>
      </li>
    </ul>

    <!-- Empty state -->
    <div *ngIf="!loading && filteredWorkspaces.length === 0" class="px-4 py-8 text-center">
      <p class="text-sm text-gray-500 dark:text-gray-400">
        {{ searchQuery ? 'No workspaces found' : 'No workspaces available' }}
      </p>
    </div>

    <!-- Create new workspace option -->
    <div *ngIf="showCreateOption" class="border-t border-gray-200 dark:border-gray-600 mt-2 pt-2">
      <button (click)="createNewWorkspace($event)"
              class="w-full flex items-center px-4 py-2 text-sm rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
        <svg class="w-5 h-5 mr-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        <span class="font-medium text-gray-700 dark:text-gray-200">Create new workspace</span>
      </button>
    </div>
  </div>
</div>
